module.exports = __webpack_public_path__ + "static/media/icon-1.c561cfe3.svg";